
export const currentWizardStep = (state) => {
    return state.wizardData.currentWizardStep;
}

export const flow_current_step = (state) => {
    //return this.steps[this.currentstep].flow_current_step
    return state.wizardData.steps[state.wizardData.currentWizardStep - 1].flow_current_step
}

export const flow_count = (state) => {
    //return this.steps[this.currentstep].flow_steps.length
    return state.wizardData.steps[state.wizardData.currentWizardStep - 1].flow_steps.length
}

export const nextDisabled = (state) => {
    return state.wizardData.nextDisabled
}

export const skipExitConfirmation = (state) => {
    return state.wizardData.skipExitConfirmation
}

export const backDisabled = (state) => {
    return state.wizardData.backDisabled
}

export const stepEnum = (state) => {
    console.log("in stepEnum getter");
    return state.stepEnum;
}

// True for a partner-based quote (partner ID present) or a Verint third party link (thirdparty=true, no partner ID)
export const thirdPartyQuote = (state) => {
    return state.wizardData.thirdParty.ThirdPartyPartnerID !== 0 || state.wizardData.thirdParty.IsThirdParty
}



// WEBPACK FOOTER //
// ./src/store/modules/wizard/getters.js